import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import routes from 'app/routes';

import List from './Views/List/Index';
import New from './Views/New/Index';
import Edit from './Views/Edit/Index';
import Calculator from './Views/Calculator/Index';

export default function Main() {
  const router = createBrowserRouter([
    {
      path: routes.affiliates.prospects.index,
      element: <List />,
      children: [
        {
          path: routes.affiliates.prospects.new,
          element: <New />,
        },
        {
          path: routes.affiliates.prospects.edit(),
          element: <Edit />,
        },
      ],
    },
    {
      path: routes.affiliates.prospects.calculator,
      element: <Calculator />,
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}
